import { discount } from "./core.js"

/**
 * The money a discount takes off each element of a sub-array.
 *
 * The branch itself lives in `core.discount`, shared with `header.discount`, so
 * a line and a document cannot round differently or disagree about what an
 * unset type means. This is the loop around it.
 *
 * Config:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'sub.discount',
 *     subEntity: 'lines',
 *     typeField: 'discountType',                    // 'percentage' | 'amount'
 *     valueField: 'discountValue',                  // what the user typed
 *     baseField: 'netSalesAmountBeforeDiscount',    // what it applies to
 *     targetField: 'discountAmount',
 *     decimals: 2
 * }
 */
const subDiscount = (data, operation) => {
    const { subEntity, typeField, valueField, baseField, targetField, decimals = 2 } = operation

    if (!data || !Array.isArray(data[subEntity])) {
        return data
    }

    const newSubArray = data[subEntity].map(elem => ({
        ...elem,
        [targetField]: discount(elem[typeField], Number(elem[valueField]), Number(elem[baseField]), decimals)
    }))

    return {
        ...data,
        [subEntity]: newSubArray
    }
}

export default subDiscount
